import { Action } from '@ngrx/store';
import * as MedicalConditionResultActions from 'src/app/pages/medical-underwriting/store/actions/medicalCondition.action';


export type Actions = MedicalConditionResultActions.Actions;

export function MedicalConditionReducer(state: any[] = [],
    action: MedicalConditionResultActions.Actions) {
    switch (action.type) {
        case MedicalConditionResultActions.ADD_MEDICALCONDITION_RESULT:
            return [...state, action.payload];

        // Add this case:
        case MedicalConditionResultActions.REMOVE_MEDICALCONDITION_RESULT:
            return [...state].splice(action.payload, 1);
        default:
            return state;
    }
}

